module.exports = __webpack_public_path__ + "media/orderscreen_selfservice.47dc1dac.webm";